(function () {
    'use strict';

    angular.module("imApp").factory("choicePossRulesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1158,
                    parameters: parms || {}
                });
            },
            changeModelId: function (setting) {
                return $ihttp.post({
                    method: 1190,
                    parameters: setting
                });
            },
            changeChoiceProductId: function (setting) {
                return $ihttp.post({
                    method: 1185,
                    parameters: setting
                });
            },
            listFurnitureFabrics: function (parms) {
                return $ihttp.post({
                    method: 1173,
                    parameters: parms || {}
                });
            },
            listChosenProducts: function (parms) {
                return $ihttp.post({
                    method: 1175,
                    parameters: parms || {}
                });
            },
            listRules: function (parms) {
                return $ihttp.post({
                    method: 1178,
                    parameters: parms || {}
                });
            },
            listProductNames: function (parms) {
                return $ihttp.post({
                    method: 1191,
                    parameters: parms || {}
                });
            },
            getProdKeyno: function (setting) {
                return $ihttp.post({
                    method: 1192,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
